module.exports = __webpack_public_path__ + "static/media/arrowRight.b0ef9544.svg";